import { render, staticRenderFns } from "./TeacherFeedbackFilter.vue?vue&type=template&id=04d113c1&scoped=true"
import script from "./TeacherFeedbackFilter.vue?vue&type=script&lang=js"
export * from "./TeacherFeedbackFilter.vue?vue&type=script&lang=js"
import style0 from "./TeacherFeedbackFilter.vue?vue&type=style&index=0&id=04d113c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d113c1",
  null
  
)

export default component.exports